export default __webpack_public_path__ + "static/media/402.b43d3a29.gif";